import { API_URL } from './apiConfig';
import { isNativeApp } from './native';

export function supportsWebPush() {
  return !isNativeApp() && window.isSecureContext &&
    'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

async function pushRequest(path, method = 'GET', body) {
  const token = localStorage.getItem('token');
  if (!token || localStorage.getItem('impersonate_user_id')) throw new Error('Sign in as yourself to enable notifications.');
  const response = await fetch(`${API_URL}/api/push/web/${path}`, {
    method,
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  if (!response.ok) throw new Error('Could not save notification settings. Please try again.');
  return response.json();
}

export const getWebPushConfig = () => pushRequest('config');

async function registration() {
  await navigator.serviceWorker.register('/push-sw.js', { scope: '/' });
  return navigator.serviceWorker.ready;
}

function applicationServerKey(value) {
  const padded = value.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(value.length / 4) * 4, '=');
  return Uint8Array.from(atob(padded), char => char.charCodeAt(0));
}

export async function syncWebPush() {
  if (!supportsWebPush() || Notification.permission !== 'granted') return false;
  const worker = await registration();
  const subscription = await worker.pushManager.getSubscription();
  if (!subscription) return false;
  await pushRequest('subscribe', 'POST', subscription.toJSON());
  return true;
}

export async function enableWebPush(publicKey) {
  // Request immediately from the button click: iOS requires a direct user gesture.
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('Notifications are blocked. Allow them in your device notification settings, then try again.');
  const worker = await registration();
  const subscription = await worker.pushManager.getSubscription() || await worker.pushManager.subscribe({
    userVisibleOnly: true, applicationServerKey: applicationServerKey(publicKey),
  });
  await pushRequest('subscribe', 'POST', subscription.toJSON());
  return true;
}

export async function disableWebPush() {
  if (!('serviceWorker' in navigator)) return;
  const worker = await navigator.serviceWorker.getRegistration('/');
  const subscription = await worker?.pushManager?.getSubscription();
  if (!subscription) return;
  // Revoke at the browser even if logout happens while the server is unreachable.
  try {
    await pushRequest('subscribe', 'DELETE', { endpoint: subscription.endpoint });
  } finally {
    await subscription.unsubscribe();
  }
}
